import { get as getCookie } from 'js-cookie'

import { credentialsCookie } from '../config'
import { AuthState }         from '../redux/index'

const storedCredentialsCookie = getCookie(credentialsCookie.name)

let credentialsObject: AuthState = {}

if (storedCredentialsCookie) {
  credentialsObject = JSON.parse(storedCredentialsCookie) as AuthState
}

export const credentials = credentialsObject



// WEBPACK FOOTER //
// ./src/project-utils/credentials-cookie.ts